import {
  CrudBuilderState,
  didError,
  didSucceed,
  getFetchAllSlice,
  getFetchSlice,
  hasStarted
} from "seneca-common/utils/apiStates";

type State = CrudBuilderState;

// Fetch single course stat
function getCourseStatsFetchStateSlice(state: State, courseId: string) {
  return getFetchSlice(state).get(courseId);
}

export function courseStatFetching(state: State, courseId: string): boolean {
  const meta = getCourseStatsFetchStateSlice(state, courseId);
  return !!meta && hasStarted(meta);
}

export function courseStatFetchSucceeded(
  state: State,
  courseId: string
): boolean {
  const meta = getCourseStatsFetchStateSlice(state, courseId);
  return !!meta && didSucceed(meta);
}

export function courseStatFetchErrored(
  state: State,
  courseId: string
): boolean {
  const meta = getCourseStatsFetchStateSlice(state, courseId);
  return !!meta && didError(meta);
}

export function courseStatFetchFinished(state: State, courseId: string) {
  return (
    courseStatFetchSucceeded(state, courseId) ||
    courseStatFetchErrored(state, courseId)
  );
}

export function courseStatNeedsFetching(state: State, courseId: string) {
  return !(
    courseStatFetchSucceeded(state, courseId) ||
    courseStatFetching(state, courseId)
  );
}

// fetch all course stats
function getAllCourseStatsFetchStateSlice(state: State) {
  return getFetchAllSlice(state);
}

export function allCourseStatsFetching(state: State): boolean {
  return hasStarted(getAllCourseStatsFetchStateSlice(state));
}

export function allCourseStatsFetchSucceeded(state: State): boolean {
  return didSucceed(getAllCourseStatsFetchStateSlice(state));
}

export function allCourseStatsFetchErrored(state: State): boolean {
  return didError(getAllCourseStatsFetchStateSlice(state));
}

export function allCourseStatsFetchFinished(state: State) {
  return (
    allCourseStatsFetchSucceeded(state) || allCourseStatsFetchErrored(state)
  );
}

export function allCourseStatsNeedsFetching(state: State) {
  return !(
    allCourseStatsFetchSucceeded(state) || allCourseStatsFetching(state)
  );
}
